import supabase from '../supabaseClient';
import { TABLE_NAMES } from '../config';

async function resolveVenueDisplayName(venueOwnerValue) {
  const raw = String(venueOwnerValue || '').trim();
  if (!raw) return 'your venue';

  if (raw.toLowerCase() === 'true') {
    const { data } = await supabase
      .from('replay_venues')
      .select('name')
      .eq('is_active', true)
      .order('name')
      .limit(1)
      .maybeSingle();
    return data?.name || 'your venue';
  }

  return raw;
}

/**
 * Returns membership info when the user is already linked to a venue
 * (Users.venue_owner is set). Otherwise null.
 */
export async function fetchExistingVenueMembership(userId) {
  if (!userId) return null;

  const { data: userProfile, error: profileError } = await supabase
    .from(TABLE_NAMES.USERS)
    .select('venue_owner')
    .eq('user_id', userId)
    .maybeSingle();

  const venueOwnerValue = String(userProfile?.venue_owner || '').trim();
  if (profileError || !venueOwnerValue) return null;

  const venueName = await resolveVenueDisplayName(venueOwnerValue);

  return {
    venueOwnerValue,
    venueName: venueName || 'your venue',
  };
}

export function shouldAllowVenueSignupFlow(venueOwnerValue) {
  return !String(venueOwnerValue || '').trim();
}

export function venueOwnerLoginRedirectState(venueName) {
  return { alreadyInVenue: venueName || 'your venue' };
}

export { resolveVenueDisplayName };
